import api from '../../plugins/api';

// Номер телефона бэк берёт из карточки клиента сделки — в запросе его нет.
const sendClientUploadSms = ({ dealId, kinds }) => {
  return api.post('/api/crm/clientUpload/sendSms', { dealId, kinds });
};

export default sendClientUploadSms;
